import {showCountryTooltip, setCountryTooltipText, hideCountryTooltip} from "./countryTooltip.js";

function addMapEventListeners(map, onRegionClick) {
    map.data.addListener('mouseover', function (event) {
        var clickable = event.feature.getProperty("clickable");
        if (clickable) {
            map.data.overrideStyle(event.feature, {
                strokeWeight: 1.5,
                strokeColor: '#a81c22',
                strokeOpacity: 1,
                cursor: 'pointer'
            });
            showCountryTooltip();
            setCountryTooltipText(event.feature.getId());
        }
    });
    map.data.addListener('mouseout', function (event) {
        map.data.overrideStyle(event.feature, { strokeOpacity: 0.0 });
        hideCountryTooltip();
    });
    map.data.addListener('click', (event) => {
        var clickable = event.feature.getProperty("clickable");
        if (clickable) {
            var id = event.feature.getProperty("regionId");
            onRegionClick(id);
        }
    });
}

function clearMapEventListeners(map){
        google.maps.event.clearListeners(map.data, 'mouseover');
        google.maps.event.clearListeners(map.data, 'mouseout');
        google.maps.event.clearListeners(map.data, 'click');
    }

export { addMapEventListeners, clearMapEventListeners };